<form #f="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <syn-assessment-selection (selectAssessments)="addAssessment($event)" />
    <div [ngClass]="{ ok: selectedAssessments.length || !assessmentSent }" class="error-message">
      Aucun questionnaire sélectionné
    </div>
    <syn-date-picker [enable]="enableDate" (date)="onNewDate($event)" />
    @if (send) {
    <div class="spinner-border text-primary ms-2" style="width: 2rem; height: 2rem" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    }
  </div>
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button mat-dialog-close>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!isSubmitOk">Importer</button>
  </mat-dialog-actions>
</form>
